import { NewPostPayload } from 'api';
import { removeExtraSpaces } from 'utils';

interface FormValuesAdapterProps {
  title: string;
  description: string;
  type: string;
  tags: string[];
  newsfeed: boolean;
  profiles: string[];
  attachment_ids?: string[];
  file_ids?: string[];
  group_visibility: string;
  assigned_to: string[];
  notify: boolean;
  pin: boolean;
  visibility?: string[];
}

export function formValuesAdapter({
  title,
  description,
  attachment_ids,
  visibility,
  ...otherProps
}: FormValuesAdapterProps): NewPostPayload {
  return {
    title: removeExtraSpaces(title),
    description: removeExtraSpaces(description),
    ...(!!attachment_ids?.length && { attachments: attachment_ids }),
    ...(visibility && { assigned_to: visibility }),
    ...otherProps,
  };
}
